export const alert_category_list = ["Vaccination", "Deworming", "Membership", "Grooming Add Ons"];